import axios, { AxiosResponse } from "axios";
import { appConfig } from "../config/keycloak";
class TemplateService {

    private readonly api = axios.create({
        baseURL: appConfig.baseUrl
    });

    constructor() {
        // Empty constructor, configuration is in the api instance
    }


    /**
    * Get funding document template
    */
    public getFundingDocumentTemplate(token: string): Promise<AxiosResponse<any>> {
        return this.api.get(
            `/template-service/api/templates/FUNDING_DOCUMENT`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }

    /**
     * Get SMS template for pre-approval
     */
    public getPreApprovalSmsTemplate(token: string): Promise<AxiosResponse<any>> {
        return this.api.get(
            `/template-service/api/templates/PREAPPROVAL_SMS`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }

    /**
     * Get Email template for pre-approval
     */
    public getPreApprovalEmailTemplate(token: string): Promise<AxiosResponse<any>> {
        return this.api.get(
            `/template-service/api/templates/_PREAPPROVAL_EMAIL_`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }

    /**
     * Get Email template for application created notification
     */
    public getApplicationCreatedEmailTemplate(token: string): Promise<AxiosResponse<any>> {
        return this.api.get(
            `/template-service/api/templates/APPLICATION_CREATED_EMAIL`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }

    /**
     * Get Email template for decline notification
     */
    public getDeclineEmailTemplate(token: string): Promise<AxiosResponse<any>> {
        return this.api.get(
            `/template-service/api/templates/DECLINE_EMAIL`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }

    /**
     * Get SMS template for decline notification
     */
    public getDeclineSmsTemplate(token: string): Promise<AxiosResponse<any>> {
        return this.api.get(
            `/template-service/api/templates/DECLINE_SMS`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }


    public getTemplateByName(token: string, templateName: string): Promise<AxiosResponse<any>> {
        return this.api.get(
            `/template-service/api/templates/${templateName}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }


    public getAddendumState1Template(token: string): Promise<AxiosResponse<any>> {
        return this.api.get(
            '/template-service/api/templates/ADDENDUM_STATE1',
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }


}

export default new TemplateService();
